import React from 'react';
import './LoginPrompt.scss';
import { Modal } from 'semantic-ui/semantic-ui-imports';
import { PromptToSignInContext } from 'contexts/promptToSignIn';
import { useTranslation } from 'react-i18next';
import Login from 'components/Login';
import { useNavigate } from 'react-router-dom';

const LoginPrompt = () => {
  const { closePromptToSignIn, promptOpen, redirectLink } = React.useContext(
    PromptToSignInContext
  );
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      onClose={() => closePromptToSignIn()}
      open={promptOpen}
      className="login-prompt"
    >
      <Modal.Header>{t('promptToSignIn.title')}</Modal.Header>
      <Modal.Content className="login-prompt__content">
        <p>{t('promptToSignIn.description')}</p>
        <Login
          onLoggedIn={() => {
            closePromptToSignIn();
            navigate(redirectLink || '/');
          }}
          onNavigateAway={() => {
            closePromptToSignIn();
          }}
        />
      </Modal.Content>
    </Modal>
  );
};

export default LoginPrompt;
